import styled from 'styled-components';
import NotificationIconSVG from './NotificationIcon.svg';
import NotificationIconClickedSVG from './NotificationIcon-clicked.svg';
import SettingIconSVG from './SettingIcon.svg';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  padding-bottom: 16px;
  background-color: #F7F5F6;

   @media (max-width: 768px) {
    overflow-x: hidden;
    width: 100%;
    padding-bottom: 32px;
    min-height: 100dvh;   
    height: 100dvh;      
  }
`;

export const Header = styled.header`
  height: 80px;
  margin: 0px 36px; /* 桌機版 */
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  background-color: #F7F5F6;


  h2 {
    margin: -10px;
  
    @media (max-width: 768px) {
      display: none;
    }
  }


  @media (max-width: 768px) {
    margin:10px 0px;
    margin-bottom:0px;
    padding: 0px 16px;
    height: 60px;
    justify-content: center; 
    position: relative;      
  }

  div {
    display: flex;
    align-items: center;
    gap: 8px;

    @media (max-width: 768px) {
    justify-content: end;
  }
  }
`;




export const LeftWrapper = styled.div`
  width: 80%;
  justify-content: space-between;
  position: relative;
`;

export const Main = styled.div`
  display: flex;
  flex: 1;
  margin: 0 36px;
  background-color: #F0EEEF;
  width: calc(100% - 72px); /* 確保在大螢幕下不會超出 */
  border-radius: 32px;
  overflow: hidden;

  @media (max-width: 768px) {
    flex-direction: column; /* 讓 Sidebar & Content 垂直排列 */
    width: 100%; /* 手機版使用 100% 避免超出 */
    margin: 16px 0px;
    overflow-x: hidden; /* 防止橫向滾動 */
  }
`;

export const Sidebar = styled.aside`
  flex: 0 0 20%;
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 8px;
  transition: left 0.3s ease-in-out;

  @media (max-width: 768px) {
    position: fixed;
    top: 0;
    left: ${({ isOpen }) => (isOpen ? '0' : '-250px')};
    width: 250px;
    height: 100dvh;
    background-color: #F0EEEF;
    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.2);
    z-index: 901;
  }
`;

export const SidebarToggle = styled.button`
  display: none;

  @media (max-width: 768px) {
    display: block;
    background: transparent;
    border: none;
    cursor: pointer;
    z-index: 902;
    font-size: 36px;
    margin-right: 8px;
    background-color: transparent;
    color: #61cbc9;
  }

  &::before {
    content: '☰'; 
  }

`;


export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  z-index: 900;
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
`;


export const Content = styled.main`
  flex: 1;
  padding: 20px;
  background-color: #ffffff;
  border-radius: 16px;
  margin: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  min-height: 80vh;  
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex: 1;
    margin: 0;
    border-radius: 0;
    padding: 15px;
  }
`;

export const LogoWrapper = styled.div`
  position: static;

  @media (max-width: 768px) {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
`;


export const LogoImage = styled.img`
  width: 160px;
  height: auto;
  object-fit: cover;

   @media (max-width: 768px) {
    
  }
`;

export const SidebarFooter = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: flex;
    position: absolute;
    bottom: 16px;
    right: 16px;
    gap: 12px;
    align-items: center;
    justify-content: flex-end;
  }
`;

export const ProfileEmail = styled.p`
  font-size: 14px;
  color: #666;
  margin: 0;
`;

export const ProfilePlaceholder = styled.div`
  height: 80px;
`;

export const ProfileImageHidden = styled.img`
  opacity: 0;
`;

export const NotificationIcon = styled.div`
  width: 32px;
  height: 32px;
  background: url(${(props) =>
    props.isClicked ? NotificationIconClickedSVG : NotificationIconSVG}) no-repeat center center;
  background-size: contain;
  position: relative;
  cursor: pointer;

  &::after {
    content: "1"; /* 通知數量 */
    position: absolute;
    top: -4px;
    right: -4px;
    background-color: #ff5a5f;
    color: #fff;
    font-size: 12px;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    display: ${(props) => (props.isClicked ? 'none' : 'flex')};
    align-items: center;
    justify-content: center;
  }
`;

export const NotificationDropdown = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  top: 60px;
  right: 0;
  width: 250px;
  background: #ffffff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  z-index: 100;

  h3 {
    margin: 0;
    text-align: left;
    width: 100%;
  }
`;

export const NotificationItem = styled.div`
  padding: 8px 8px;
  font-size: 14px;
  cursor: pointer;
  color: #333;
  background-color: transparent;
  transition: background-color 0.3s, color 0.3s;
  border-bottom: 1px solid #F2F4F8;

  &:hover {
    background-color: #61cbc9;
    color: #fff;
    border-radius: 8px;
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const SettingIcon = styled.div`
  width: 32px;
  height: 32px;
  background: url(${SettingIconSVG}) no-repeat center center;
  background-size: contain;
  cursor: pointer;
`;

export const LogoutButton = styled.button`
  background-color: #61cbc9;
  color: #ffffff;
  padding: 12px;
  font-size: 16px;
  font-weight: 500;
  border: none;
  border-radius: 8px;
  cursor: pointer;

  &:hover {
    background-color: rgba(97, 203, 201, 0.9);
    color: #fff;
  }

  &:active {
    background-color: #003f7f;
    color: #ffffff;
  }
`;

export const Profile = styled.div`
  display: flex;
  align-items: left;
  margin-bottom: 10px;
  flex-direction: column;

  img {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    object-fit: cover;
  }

  div {
    display: flex;
    flex-direction: column;

    h2 {
      margin-bottom: 10px;
      font-size: 24px;
      font-weight: bold;
      color: #333;
    }
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #ccc;
  margin: 20px 0;
`;

export const SidebarItem = styled.div`
  flex: 1;
  padding: 10px 15px;
  font-size: 16px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 6px;
  color: ${(props) => (props.active ? '#fff' : '#333')};
  background-color: ${(props) => (props.active ? '#61cbc9' : 'transparent')};
  transition: background-color 0.3s, color 0.3s;

  img {
    width: 24px;
    height: 24px;
    object-fit: contain;
    filter: ${(props) => (props.active ? 'brightness(0) invert(1)' : 'none')};
    transition: filter 0.3s;
  }

  &:hover {
    background-color: #61cbc9;
    color: #fff;

    img {
      filter: brightness(0) invert(1);
    }
  }

  a {
    text-decoration: none;
    color: inherit;
    width: 100%; /* 讓 <Link> 撐滿 SidebarItem */
    display: flex;
    align-items: center;
    gap: 10px;
  }
`;


